import { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { COLORS } from '~/styles/colors';
import { useThousandFormatter } from '~/utils/useThousandFormatter';

type ScansCountProps = {
  count: number;
} & ComponentProps<typeof Box>;

const ScansCount = ({ count, ...rest }: ScansCountProps) => {
  const { t } = useTranslation();
  const formatNumber = useThousandFormatter();

  return (
    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" {...rest}>
      <Typography fontSize={48} lineHeight="112%">
        {formatNumber(count) || '-'}
      </Typography>
      <Typography fontSize={14} mb={3} color={COLORS.purple} textAlign="center">
        {t('qrDetail:totalScan')}
      </Typography>
    </Box>
  );
};

export default ScansCount;
